import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ParameterDeviceComponent } from '../../devices/parameter/parameter-device.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-parameter-device',
    templateUrl: './modal-device-parameter.component.html',
    styleUrls: ['./modal-device-parameter.component.scss'],
    imports: [ParameterDeviceComponent, TranslatePipe]
})
export class ModalDeviceParameter implements OnInit {
  deviceId: string;

  constructor(
    public activeModal: NgbActiveModal,
  ) {  }

  ngOnInit(): void { }

}
